import React, { memo, useMemo } from 'react';
import { CourseBuilder } from '../types';
import { BlockContainer } from '../BlockContainer';
import classNames from 'classnames';
import { formGroup, formControl, FormDataType } from '@core/utils/form';
import { defineBlockAdvanceForm } from '../Common/AdvanceSettings';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { useConfigureBlock } from '@modules/course/CourseBuilder/hooks';
import { TestBlockSettings } from './TestBlockSettings';
import { Container } from 'reactstrap';
import { FormHTMLInline } from '@core/components/form';
import { useCourseBuilderContext } from '../../CourseBuilderPage';
import { css } from '@emotion/react';

function defineTestBlockForm() {
  return formGroup({
    text: formControl<string>({
      initialValue: `<ol><li>Vel magna iaculis arcu cursus parturient blandit suscipit taciti auctor maecenas.</li><li>Penatibus libero risus montes conubia pretium quisque ut fermentum, vulputate augue litora ornare fames turpis convallis imperdiet, curae etiam sed enim dictumst purus sit.</li><li>Tortor parturient gravida habitant dapibus et fusce felis nam nibh litora ridiculus aenean porttitor turpis pharetra.</li><li>Suscipit montes natoque aptent ex gravida orci ultrices volutpat nunc.</li></ol>`,
    }),
    advance: defineBlockAdvanceForm(),
  });
}

export type TestWidgetFormData = FormDataType<typeof defineTestBlockForm>;
export type TestWidgetForm = ReturnType<typeof defineTestBlockForm>;

export enum TestBlockVariation {
  listMatching = 'listMatching',
  multipleChoiceTest = 'multipleChoiceTest',
}

export const TestBlock = memo((props: CourseBuilder.BlockProps<TestBlockVariation>) => {
  const { variation, preview, editable } = props;
  const form = useMemo(defineTestBlockForm, []);
  const formValue = useNonNilObservable(form.value$);
  const proposal = useCourseBuilderContext();
  const primaryColor = useMemo(() => proposal?.form.value.primaryColor, [proposal]);

  const listCss = useMemo(() => {
    if (primaryColor) {
      return css`
        li:before {
          background-color: ${primaryColor};
        }
      `;
    } else {
      return css`
        li:before {
          background-color: #45a8f7;
        }
      `;
    }
  }, [primaryColor]);

  useConfigureBlock({
    props,
    form,
    contentComponent: TestBlockSettings,
    contentProps: { form, variation },
  });

  return (
    <Container>
      <BlockContainer className={classNames('d-flex flex-fill', 'block-list', variation)} advanceForm={formValue.advance}>
        <div css={listCss}>
          <FormHTMLInline control={form.controls.text} readonly={true} />
        </div>
      </BlockContainer>
    </Container>
  );
});
